module.exports = __webpack_public_path__ + "static/Lamentum5-528b61c84aec71631c0c3761c4d7c7ce.webp";